export const GET_COMPANIES = `global/hooks/useCompany/getAllCompanies`
